import { render, staticRenderFns } from "./PackageOrders.vue?vue&type=template&id=1c657e49&scoped=true&"
import script from "./PackageOrders.vue?vue&type=script&lang=js&"
export * from "./PackageOrders.vue?vue&type=script&lang=js&"
import style0 from "./PackageOrders.vue?vue&type=style&index=0&id=1c657e49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c657e49",
  null
  
)

export default component.exports